module.exports = __webpack_public_path__ + "img/Invest.4fc90881.svg";